import { render } from "./DuplicateTrimModal.vue?vue&type=template&id=183652d8"
import script from "./DuplicateTrimModal.vue?vue&type=script&lang=js"
export * from "./DuplicateTrimModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__